document.addEventListener('DOMContentLoaded', function () {
	console.log('✅ search redirect loaded');

	// Ambil elemen input pencarian
	const searchInput = document.querySelector('input[type="search"]');
	if (!searchInput || !searchInput.form) return;

	const form = searchInput.form;

	// 🔸 Daftar kata → koleksi
	const collectionRedirects = {
'aksesoris': '/id/collections/aksesoris',
'anak': '/id/collections/anak',
'archelon': '/id/collections/archelon',
'baju': '/id/collections/baju',
'baju kaos': '/id/collections/baju-kaos',
'baju wanita': '/id/collections/baju-wanita',
'bawahan': '/id/collections/bawahan',
'celana': '/id/collections/celana',
'celana anak': '/id/collections/celana-anak',
'celana cargo': '/id/collections/celana-cargo',
'celana cargo pria': '/id/collections/celana-cargo-pria',
'celana cargo wanita': '/id/collections/celana-cargo-wanita',
'celana cream': '/id/collections/celana-cream',
'celana hitam': '/id/collections/celana-hitam',
'celana jogger': '/id/collections/celana-jogger',
'celana jogger pria': '/id/collections/celana-jogger-pria',
'celana jogger wanita': '/id/collections/celana-jogger-wanita',
'celana panjang': '/id/collections/celana-panjang',
'celana panjang anak': '/id/collections/celana-panjang-anak',
'celana panjang pria': '/id/collections/celana-panjang-pria',
'celana panjang wanita': '/id/collections/celana-panjang-wanita',
'celana pantai': '/id/collections/celana-pantai',
'celana pantai pria': '/id/collections/celana-pantai-pria',
'celana pantai wanita': '/id/collections/celana-pantai-wanita',
'celana pendek': '/id/collections/celana-pendek',
'celana pendek anak': '/id/collections/celana-pendek-anak',
'celana pendek pria': '/id/collections/celana-pendek-pria',
'celana pendek wanita': '/id/collections/celana-pendek-wanita',
'celana pria': '/id/collections/celana-pria',
'celana renang pria': '/id/collections/celana-renang-pria',
'celana training': '/id/collections/celana-training',
'celana training pria': '/id/collections/celana-training-pria',
'celana training wanita': '/id/collections/celana-training-wanita',
'celana wanita': '/id/collections/celana-wanita',
'dress': '/id/collections/dress',
'filmmaker': '/id/collections/filmmaker',
'gore tex': '/id/collections/gore-tex',
'hoodie': '/id/collections/hoodie',
'hoodie anak': '/id/collections/hoodie-anak',
'hoodie pria': '/id/collections/hoodie-pria',
'hoodie wanita': '/id/collections/hoodie-wanita',
'jaket': '/id/collections/jaket',
'jaket bomber': '/id/collections/jaket-bomber',
'jaket bulu angsa': '/id/collections/jaket-bulu-angsa',
'jaket hoodie': '/id/collections/jaket-hoodie',
'jaket pria': '/id/collections/jaket-pria',
'jaket wanita': '/id/collections/jaket-wanita',
'jumpers pria': '/id/collections/jumpers-pria',
'kaos': '/id/collections/kaos',
'kaos hitam': '/id/collections/kaos-hitam',
'kaos hitam pria': '/id/collections/kaos-hitam-pria',
'kaos lengan panjang': '/id/collections/kaos-lengan-panjang',
'kaos lengan panjang pria': '/id/collections/kaos-lengan-panjang-pria',
'kaos polo pria': '/id/collections/kaos-polo-pria',
'kaos polo wanita': '/id/collections/kaos-polo-wanita',
'kaos pria': '/id/collections/kaos-pria',
'kaos sablon': '/id/collections/kaos-sablon',
'kaos wanita': '/id/collections/kaos-wanita',
'kaus kaki': '/id/collections/kaus-kaki',
'kemeja': '/id/collections/kemeja',
'kemeja pria': '/id/collections/kemeja-pria',
'kemeja wanita': '/id/collections/kemeja-wanita',
'kids tops': '/id/collections/kids-tops',
'koper': '/id/collections/koper',
'leucos': '/id/collections/leucos',
'nrn': '/id/collections/nrn',
'outer': '/id/collections/outer',
'outer pria': '/id/collections/outer-pria',
'outer wanita': '/id/collections/outer-wanita',
'pakaian': '/id/collections/pakaian',
'pakaian pria': '/id/collections/pakaian-pria',
'pakaian wanita': '/id/collections/pakaian-wanita',
'ransel': '/id/collections/ransel',
'ransel anak': '/id/collections/ransel-anak',
'rash guard pria': '/id/collections/rash-guard-pria',
'rash guards': '/id/collections/rash-guards',
'rok': '/id/collections/rok',
'rompi': '/id/collections/rompi',
'rompi pria': '/id/collections/rompi-pria',
'rompi wanita': '/id/collections/rompi-wanita',
'sarung tangan': '/id/collections/sarung-tangan',
'sweater': '/id/collections/sweater',
'sweater anak': '/id/collections/sweater-anak',
'sweater hoodie': '/id/collections/sweater-hoodie',
'sweater pria': '/id/collections/sweater-pria',
'sweater wanita': '/id/collections/sweater-wanita',
'tas': '/id/collections/tas',
'tas anak': '/id/collections/tas-anak',
'tas koper': '/id/collections/tas-koper',
'tas pria': '/id/collections/tas-pria',
'tas ransel': '/id/collections/tas-ransel',
'tas ransel pria': '/id/collections/tas-ransel-pria',
'tas ransel wanita': '/id/collections/tas-ransel-wanita',
'tas selempang': '/id/collections/tas-selempang',
'tas selempang pria': '/id/collections/tas-selempang-pria',
'tas selempang wanita': '/id/collections/tas-selempang-wanita',
'tas wanita': '/id/collections/tas-wanita',
'topi': '/id/collections/topi',
'topi anak': '/id/collections/topi-anak',
'topi bucket': '/id/collections/topi-bucket',
'topi pria': '/id/collections/topi-pria',
'topi rimba': '/id/collections/topi-rimba',
'tops': '/id/collections/tops',
'tote bags': '/id/collections/tote-bags',
'tumbler': '/id/collections/tumbler',
'baju crop top': '/id/collections/crop-tops',
'tote bag wanita': '/id/collections/tote-bag-wanita',
'jaket gunung': '/id/collections/jaket-gunung',
'topi baseball': '/id/collections/topi-baseball',
'kupluk': '/id/collections/topi-kupluk',
'baju kaos pria': '/id/collections/baju-kaos-pria',
'tas kecil': '/id/collections/tas-kecil',
'jaket bomber pria': '/id/collections/jaket-bomber-pria',
'kaos putih': '/id/collections/kaos-putih',
'jaket outdoor': '/id/collections/jaket-outdoor',
'celana cargo pendek': '/id/collections/celana-cargo-pendek',
'topi wanita': '/id/collections/topi-wanita',
'tas kecil pria': '/id/collections/tas-kecil-pria',
'tas ransel kecil': '/id/collections/tas-ransel-kecil',
'rok hitam': '/id/collections/rok-hitam',
'celana cargo panjang pria': '/id/collections/celana-cargo-panjang-pria',
'celana training hitam': '/id/collections/celana-training-hitam',
'celana putih': '/id/collections/celana-putih',
'celana hitam wanita': '/id/collections/celana-hitam-wanita',
'celana abu abu': '/id/collections/celana-abu-abu',
'jaket anti air': '/id/collections/jaket-anti-air',
'celana cargo panjang': '/id/collections/celana-cargo-panjang',
'celana khaki': '/id/collections/celana-khaki',
'topi hitam': '/id/collections/topi-hitam',
'jaket winter': '/id/collections/jaket-winter',
'kaos logo': '/id/collections/kaos-logo'
	};

	form.addEventListener('submit', function (e) {
		const val = (searchInput.value || '').toLowerCase().trim();

		if (collectionRedirects[val]) {
			e.preventDefault();
			const target = collectionRedirects[val];

			// Tambah tracking parameter UTM / ref
			const redirectURL = `${target}`;

			window.location.href = redirectURL;
		}
	});
});
